import React from "react"

const Hero = () => (
<section className="jl-slides">
        <div className="slick-slide" style={{ backgroundImage: "url(/images/slider/inTheStore.png)"}}>
            <div className="slide-inner">
                <h1 id="main" className="subheader">Ready to Sell?</h1>
                <div><h2 className="header">Jiffy Lube is Ready to Buy<br/>When You’re Ready to Sell</h2></div>
                <p>Jiffy Lube, the most preferred provider in the industry, continues to expand its footprint, adding more locations to the network of over 2,000 service centers across North America. One of the ways the brand is growing is to purchase existing fast lube centers. So, if you own a service center, when you’re ready to sell, we’re ready to buy!</p>                
            </div>
        </div>
    </section>
)

export default Hero